import React from 'react';
import BottomPostcodeSection from './BottomPostCodeSection';
import { graphql } from 'gatsby';
const ModularArrowHeadingPostcode = ({ data }) => {
  return (
    <div className="modular-arrow-heading-postcode-container">
      {data?.bottomPostcodeContent?.map(
        ({ heading, content, backgroundColor }) => {
          return (
            <BottomPostcodeSection
              heading={heading}
              content={content}
              backgroundColor={backgroundColor}
            />
          );
        },
      )}
    </div>
  );
};

export default ModularArrowHeadingPostcode;
export const fragment = graphql`
  fragment ModularArrowHeadingPostcode on DatoCmsBottomPostcode {
    internal {
      type
    }
    bottomPostcodeContent {
      content
      heading
      backgroundColor
    }
  }
`;
